var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H4C2.9 2 2 2.9 2 4V18C2 19.1 2.9 20 4 20H18C19.1 20 20 19.1 20 18V4C20 2.9 19.1 2 18 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C18.5523 3 19 3.44772 19 4V18C19 18.5523 18.5523 19 18 19H4C3.44772 19 3 18.5523 3 18V4C3 3.44772 3.44772 3 4 3H18ZM18 2H4C2.9 2 2 2.9 2 4V18C2 19.1 2.9 20 4 20H18C19.1 20 20 19.1 20 18V4C20 2.9 19.1 2 18 2Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxIcon);
export default __webpack_public_path__ + "static/media/CheckBoxIcon.fcb6cacf9054e51331b530437c664edc.svg";
export { ForwardRef as ReactComponent };